import { ChannelType } from '@wix/ambassador-events-v1-order/types';
import { isUnpaidOrderStatus } from './order';
export const isTicketWithPricingOption = (ticket) => !!ticket?.ticketDetails?.pricingOptionId;
export const isTicketWithEmail = (ticket) => !!ticket?.guestDetails?.email;
export const isTicketCheckedIn = (ticket) => !!ticket.checkIn;
export const getTicketCheckInDate = (ticket) => ticket.checkIn?.created;
export const isTicketAssigned = (ticket) => !!ticket.guestDetails?.guestAssigned;
export const isUnpaidTicket = (ticket) => isUnpaidOrderStatus(ticket.orderStatus) && !ticket.free;
export const isPosTicket = (ticket) => ticket.channel === ChannelType.OFFLINE_POS;
export const isAreaTicket = (ticket) => !!ticket.ticketDetails.areaName;
export const isRowTicket = (ticket) => !!ticket.ticketDetails.rowNumber;
export const isTableTicket = (ticket) => !!ticket.ticketDetails.tableName;
export const getTicketPriceWithoutTax = (order, ticket) => {
    const invoiceItems = order.invoice?.items;
    const amount = ticket.ticketDetails?.priceOverride ??
        invoiceItems?.find(item => item.id === ticket.ticketDefinitionId)?.price?.amount;
    const currency = ticket.price?.currency;
    return amount ? { amount, value: amount, currency } : undefined;
};
export const getTicketNameWithPricingOption = (ticket) => isTicketWithPricingOption(ticket) ? `${ticket.name} (${getTicketPricingOptionName(ticket)})` : ticket.name;
export const getTicketPricingOptionName = (ticket) => ticket.ticketDetails.pricingOptionName;
export const formatLabeledTicketPrice = (ticket, priceFormatter) => isTicketWithPricingOption(ticket) ? formatPricingOptionPrice(ticket, priceFormatter) : priceFormatter(ticket.price);
export const formatPricingOptionPrice = (ticket, priceFormatter) => `${getTicketPricingOptionName(ticket)} ${priceFormatter(ticket.price)}`;
//# sourceMappingURL=ticket.js.map